/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Game_Rule_ViolationInputs */



/**
* | output |
* | --- |
* | "Game Rule Violation" |
*
* @param {Sanction_Sub_Game_Rule_ViolationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_game_rule_violation = /** @type {((inputs?: Sanction_Sub_Game_Rule_ViolationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Game_Rule_ViolationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Violation des Règles de Jeu")
	if (locale === "es") return /** @type {LocalizedString} */ ("Violación de Reglas de Juego")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Violação das Regras de Jogo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Violazione delle Regole di Gioco")
	return /** @type {LocalizedString} */ ("Game Rule Violation")
});